module.exports = __webpack_public_path__ + "static/media/Through sky.95a63dea.jpg";